/**
 *   Generated file. Do not edit
 */
import { TapResponse } from '@iotize/tap';
import { SERVICE_CALLS } from './service-calls';

import { LocalTime } from './models';
import { AbstractService, ServiceCallType } from '@iotize/tap';

export class TimeService extends AbstractService {
  public resources = SERVICE_CALLS;

  /**
   * Get NTP server name
   *
   * LWM2M path: /1024//77
   *
   * @tapVersion(">=1.107")
   * @return
   */
  getNtpServer(): Promise<TapResponse<string>> {
    return this.serviceCallRunner.execute(this.getNtpServerCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//77
   *
   * @tapVersion(">=1.107")
   * @return call options
   */
  getNtpServerCall(): ServiceCallType {
    const callOptions = { ...this.resources.getNtpServer };

    return callOptions;
  }

  /**
   * Put NTP server name
   *
   * LWM2M path: /1024//77
   *
   * @tapVersion(">=1.107")
   * @param serverName input
   * @return
   */
  putNtpServer(
    /*
     *
     */
    serverName: string,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putNtpServerCall(serverName));
  }

  /**
   *
   *
   * LWM2M path: /1024//77
   *
   * @tapVersion(">=1.107")
   * @param serverName input
   * @return call options
   */
  putNtpServerCall(
    /*
     *
     */
    serverName: string,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putNtpServer };

    callOptions.body = serverName;

    return callOptions;
  }

  /**
   * Get Tap time zone
   *
   * LWM2M path: /1024//78
   *
   * @tapVersion(">=1.107")
   * @return
   */
  getTimeZone(): Promise<TapResponse<string>> {
    return this.serviceCallRunner.execute(this.getTimeZoneCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//78
   *
   * @tapVersion(">=1.107")
   * @return call options
   */
  getTimeZoneCall(): ServiceCallType {
    const callOptions = { ...this.resources.getTimeZone };

    return callOptions;
  }

  /**
   * Put Tap time zone
   *
   * LWM2M path: /1024//78
   *
   * @tapVersion(">=1.107")
   * @param serverName input
   * @return
   */
  putTimeZone(
    /*
     *
     */
    serverName: string,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putTimeZoneCall(serverName));
  }

  /**
   *
   *
   * LWM2M path: /1024//78
   *
   * @tapVersion(">=1.107")
   * @param serverName input
   * @return call options
   */
  putTimeZoneCall(
    /*
     *
     */
    serverName: string,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putTimeZone };

    callOptions.body = serverName;

    return callOptions;
  }

  /**
   * Get Tap local time
   *
   * LWM2M path: /1024//79
   *
   * @tapVersion(">=1.107")
   * @return
   */
  getLocalTime(): Promise<TapResponse<LocalTime>> {
    return this.serviceCallRunner.execute(this.getLocalTimeCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//79
   *
   * @tapVersion(">=1.107")
   * @return call options
   */
  getLocalTimeCall(): ServiceCallType {
    const callOptions = { ...this.resources.getLocalTime };

    return callOptions;
  }
}
